import React from 'react'

import { colors } from '../../constants/theme'

const SocialMail = ({ background = colors.black }) => (
  <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.667 0.333496H2.33366C1.41699 0.333496 0.675326 1.0835 0.675326 2.00016L0.666992 12.0002C0.666992 12.9168 1.41699 13.6668 2.33366 13.6668H15.667C16.5837 13.6668 17.3337 12.9168 17.3337 12.0002V2.00016C17.3337 1.0835 16.5837 0.333496 15.667 0.333496ZM15.667 3.66683L9.00033 7.83349L2.33366 3.66683V2.00016L9.00033 6.16683L15.667 2.00016V3.66683Z"
      fill={background}
    />
  </svg>
)

export default SocialMail
